<template>
  <div class="report-ve-awards">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="$route.name"></ContentHeader>
        <div class="row" id="nominations">
          <div class="col-sm-3">
            <div class="alert alert-primary text-center" role="alert">
              Nominations: {{totalPosts}}
            </div>
          </div>
          <div class="col-sm-3 mb-2">
            <label for="nominatorFilter">From Date:</label>
            <div class="input-group">
              <input type="date" ref="fromDate" name="fromDate" id="fromDate" :value="fromDate" v-on:change="validateDates()" />
            </div>
          </div>
          <div class="col-sm-3 mb-2">
            <label for="nomineeFilter">To Date:</label>
            <input type="date" ref="toDate" name="toDate" id="toDate" :value="toDate" v-on:change="validateDates()" />
          </div>          
          <div class="col-sm-3">
            <div class="mr-2 float-right alert alert-success text-center" role="alert">
              Download:
              <button type="button" class="btn btn-link p-0" v-on:click="exportToCSV()">
                <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as a CSV file"></i>
              </button>
            </div>
          </div>
        </div>
        <EquityReportEntries v-if="nominations.length > 0" :nominations="nominations"></EquityReportEntries>
        <span v-if="nominations.length === 0">
          No nominations have been submitted
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Items per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadNominations()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option :value="500">500</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ExportToCSV from '@/helpers/ExportToCSV.js'
import ContentHeader from '@/components/ContentHeader'
import EquityReportEntries from '@/components/EquityReportEntries'
import PreContentHeader from '@/components/PreContentHeader'

export default {
  components: {
    PreContentHeader,
    ContentHeader,
    EquityReportEntries
  },
  data () {
    return {
      nominations: [],
      contentReady: false,
      contentLoadError: '',
      nominationCategories: [],
      nominationCategorySelect: '-- All --',
      communityCategories: [],
      communityCategorySelect: '-- All --',
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 100,
      toDate: '',
      fromDate: ''
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    this.loadNominations()
  },
  methods: {
    exportToCSV: function () {
      var self = this
      // Map fields of nominations array that will be converted to CSV
      const items = this.nominations.map(function (x) {
        var splitData = {}
        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: (x.equity_nominator_employee_number === null) ? '' : x.equity_nominator_employee_number,
          Nominee_Name: x.equity_nominee_name[0],
          Nominee_Employee_Number: (!x.equity_employee_number[0]) ? '' : x.equity_employee_number[0],
          Nominee_Email: x.equity_nominee_email[0],
          Status: x.equity_accept_reject[0],
          Date_Of_Nomination: x.date.split('T')[0],
          Time_Of_Nomination: x.date.split('T')[1],
          Division: x.equity_nominee_email.employeehierarchy['businessunit'][0],
          HRBP_Name: x.equity_nominee_email.employeehierarchy['hrbp-name'][0],
          HRBP_Email: x.equity_nominee_email.employeehierarchy['hrbp-email'][0],
          Motivation: x.content.rendered.replace(/<strong>Motivation<\/strong>/gi, ' ').replace(/<p>/g, ' ').replace(/<\/p>/g, ' ')
        })
        return temp
      })
      console.log('items', items)
      ExportToCSV.createCSV(items, 'EmploymentEquity')
      // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
    },
    validateDates: function() {
      if (this.$refs.toDate)
        this.toDate = this.$refs.toDate.value

      if (this.$refs.fromDate)
        this.fromDate = this.$refs.fromDate.value


      if ( this.toDate !== '' && this.fromDate !== '' ) {
        this.loadNominations('&after=' + this.fromDate + 'T00:00:00&before=' + this.toDate + 'T23:59:59')
      }
      return ''
    },
    loadNominations: function (selDates = '') {
      this.contentReady = false
      WordpressRestAPI.getViewContent('employment_equity?_embed&page=' + this.currentPage + '&custom_per_page=' + this.itemsPerPage + selDates)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.nominations = response.data
          console.log('nomination', this.nominations)
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    'currentPage' (newDetails, oldDetails) {
      this.loadNominations()
    }
  }
}
</script>

<style lang="less">
  .showHideBtn {
    padding: 4px 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/routes/ReportEEquity.vue